<template>
  <div id="initMap"
        style="height:400px;width:100%;"></div>
</template>


<script>
export default {
  name: 'Maps',
  mounted() {
    // eslint-disable-next-line
    const map = new google.maps.Map(document.getElementById("initMap"), {
      center: { lat: 51.214076, lng: 6.749104 },
      styles: [
        {
          elementType: "geometry",
          featureType: "water",
          stylers: [
            {
              color: "#9ac6ff"
            }
          ]
        },
        {
          elementType: "geometry",
          featureType: "landscape.man_made",
          stylers: [
            {
              color: "#f2f6fe"
            }
          ]
        }
      ],
      zoom: 15,
      scrollwheel: false
    });
    var image=require('../assets/media/naniungo_map.png');
    // eslint-disable-next-line
    var beachMarker = new google.maps.Marker({
      position: {lat: 51.214076, lng: 6.749104},
      map: map,
      icon: image
    });
  }
}

</script>